import {
    GET_SPAREPART_EXPENSES,
    GET_SPAREPART_EXPENSE,
    ADD_SPAREPART_EXPENSE,
    UPDATE_SPAREPART_EXPENSE,
    DELETE_SPAREPART_EXPENSE,
    SET_DELETE_SPAREPART_EXPENSE_ID,
    SET_UPDATE_SPAREPART_EXPENSE_ID,
    REMOVE_DELETE_SPAREPART_EXPENSE,
    REMOVE_UPDATE_SPAREPART_EXPENSE,
    SPAREPART_EXPENSE_ERROR,
    GET_EXPENSE_DATA,
    GET_EXPENSE_STATS,
    SET_LOADING,
    CLEAR_ERRORS
} from '../actions/types';

const initialState = {
    expenses: [],
    expense: {},
    expense_data: {
        spare_parts: [],
        warehouses: [],
        users: []
    },
    expense_stats: {
        total_expenses: 0,
        total_amount: 0,
        total_quantity: 0,
        top_consumed_parts: [],
        monthly_expenses: []
    },
    update_expense: null,
    update_expense_id: null,
    delete_expense: null,
    loading: false,
    numberOfPages: 1,
    currentPage: 1,
    total_expenses: 0,
    error: null,
};

export default function (state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_LOADING:
            return {
                ...state,
                loading: true
            };

        case GET_SPAREPART_EXPENSES:
            return {
                ...state,
                expenses: payload.data,
                numberOfPages: payload.meta?.last_page || 1,
                currentPage: payload.meta?.current_page || 1,
                total_expenses: payload.meta?.total || 0,
                error: null,
                loading: false,
            };

        case GET_SPAREPART_EXPENSE:
            return {
                ...state,
                expense: payload.data,
                loading: false,
            };

        case ADD_SPAREPART_EXPENSE:
            return {
                ...state,
                expenses: [payload.data, ...state.expenses],
                error: null,
                loading: false,
            };

        case UPDATE_SPAREPART_EXPENSE:
            return {
                ...state,
                expenses: state.expenses.map(expense =>
                    expense.id === payload.data.id ? payload.data : expense
                ),
                error: null,
                loading: false,
            };

        case DELETE_SPAREPART_EXPENSE:
            return {
                ...state,
                expenses: state.expenses.filter(expense => expense.id !== payload),
                loading: false,
            };

        case GET_EXPENSE_DATA:
            return {
                ...state,
                expense_data: payload,
                error: null,
            };

        case GET_EXPENSE_STATS:
            return {
                ...state,
                expense_stats: payload,
                error: null,
            };

        case SET_DELETE_SPAREPART_EXPENSE_ID:
            return {
                ...state,
                delete_expense: state.expenses.find((item) => item.id === payload.expense_id)
            };

        case SET_UPDATE_SPAREPART_EXPENSE_ID:
            return {
                ...state,
                update_expense: state.expenses.find((item) => item.id === payload.expense_id),
                update_expense_id: payload.expense_id
            };

        case REMOVE_DELETE_SPAREPART_EXPENSE:
            return {
                ...state,
                delete_expense: null,
            };

        case REMOVE_UPDATE_SPAREPART_EXPENSE:
            return {
                ...state,
                update_expense: null,
                update_expense_id: null,
            };

        case SPAREPART_EXPENSE_ERROR:
            return {
                ...state,
                error: payload,
                loading: false,
            };

        case CLEAR_ERRORS:
            return {
                ...state,
                error: null,
                loading: false,
            };

        default:
            return state;
    }
} 